import { computed, inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { I18nParams, TranslationProvider } from '../interfaces';
import { AppLanguage } from '@core-http';

@Injectable({ providedIn: 'root' })
export class TranslationService implements TranslationProvider {
  private readonly translateService: TranslateService = inject(TranslateService);
  private readonly currentLang: WritableSignal<AppLanguage> = signal<AppLanguage>(AppLanguage.pl);

  constructor() {
    this.initialize();
  }

  translate(key: string, params?: I18nParams): string {
    return this.translateService.instant(key, params);
  }

  translateSignal(key: string, params?: I18nParams): Signal<string> {
    return computed(() => {
      this.currentLang();
      return this.translateService.instant(key, params);
    });
  }

  switchLanguage(language: AppLanguage): void {
    this.translateService.use(language);
    this.currentLang.set(language);
  }

  private initialize(): void {
    this.translateService.addLangs([AppLanguage.pl, AppLanguage.pl]);
    this.translateService.use(AppLanguage.pl);
  }
}
